module.exports = __webpack_public_path__ + "img/instagram.807d774f.png";